import { withBemMod } from '@bem-react/core';

import { cnPopup } from '../Popup.cn';

import './Popup_hideOffscreen.css';

export interface IPopupHideOffscreenProps {
    /**
     * Прячет попап если он находится за пределами контейнера/экрана
     */
    hideOffscreen?: boolean;
}

/**
 * Модификатор который прячет попап если он находится за пределами контейнера/экрана.
 * @param {IPopupNonvisualProps} props
 */
export const withHideOffscreen = withBemMod<IPopupHideOffscreenProps>(cnPopup(), {
    hideOffscreen: true,
});
